











































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

@Component({
  components: {
    DatePicker,
    'modal-confirmacion': Confirmation,
  },
})
export default class ComponenteDialogoEdicion extends Vue {
  @Prop({ default: '' }) telco: string;
  @Prop({ default: '' }) plan: string;
  @Prop({ default: '' }) destino: string;
  @Prop({ default: 0 }) cantSims: string;
  @Prop({ default: '' }) usuario: string;
  @Prop({ default: '' }) fecha: any;
  @Prop({ default: '' }) estado: any;
  @Prop({ default: 0 }) numero: number;

  inputFecha = moment();
  inputEstado = '';
  campoEstadoEditable = false;
  mostrarCuidado = false;
  mostrarConf = false;

  mounted() {
    this.inputEstado = this.estado;
    if (this.inputEstado == 'VIGENTE') {
      this.campoEstadoEditable = true;
      this.$emit('pasos', 2);
    }
    this.inputFecha = moment(this.fecha);
  }

  beforeDestroy() {
    if (this.estado == 'VIGENTE')
      this.$emit('anulado', { anular: false, registroNumero: 0 });
    this.$emit('pasos', 1);
  }

  responseModal(respuesta: any) {
    if (respuesta) {
      this.$emit('anulado', { anular: true, registroNumero: this.numero });
      this.campoEstadoEditable = false;
      this.mostrarConf = false;
      this.inputEstado = 'ANULADO';
      this.$emit('pasos', 1);
    } else {
      this.campoEstadoEditable = true;
      this.mostrarConf = false;
      this.inputEstado = 'VIGENTE';
    }
  }

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  /* @Watch('fecha')
  onPropertyFechaChanged(value: boolean, oldValue: boolean) {
    if (value != oldValue) this.inputFecha = moment(this.fecha);
  } */

  @Watch('estado')
  onPropertyEstadoChanged() {
    this.inputEstado = this.estado;
  }
}
